import { render, staticRenderFns } from "./ProcesarCompraComponent.vue?vue&type=template&id=61b8ce03"
import script from "./ProcesarCompraComponent.vue?vue&type=script&lang=js"
export * from "./ProcesarCompraComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports